import { footerGroups } from '@/mocks/home';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full px-4 py-16 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-eye-off-line text-lg" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-black tracking-wide text-background-50">黑料反差</span>
                <span className="mt-1 font-label text-[10px] tracking-[0.28em] text-primary-200">
                  HEILIAOFANCHA
                </span>
              </span>
            </div>

            <p className="mt-6 max-w-md text-sm leading-relaxed text-background-200">
              一个把线索、时间与出处整理成索引的反差档案站。全站条目均来自公开信息聚合与虚构演绎，
              不指向任何真实个人，仅供内容创作与信息整理方法参考。
            </p>

            <div className="mt-7 flex items-center gap-2">
              {['ri-rss-line', 'ri-mail-line', 'ri-github-line', 'ri-share-forward-line'].map((icon) => (
                <a
                  key={icon}
                  href="#top"
                  aria-label="站内入口"
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-primary-800 text-primary-200 transition-colors hover:border-primary-400 hover:text-background-50"
                >
                  <i className={icon} />
                </a>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:col-span-7">
            {footerGroups.map((group) => (
              <div key={group.title}>
                <h3 className="font-label text-[11px] uppercase tracking-[0.22em] text-primary-300">
                  {group.title}
                </h3>
                <ul className="mt-5 flex flex-col gap-3">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="text-sm text-background-200 transition-colors hover:text-background-50"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-primary-900 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-label text-xs text-primary-300">© {year} 黑料反差 · 反差档案库</p>
          <p className="text-xs text-primary-300">
            内容均为公开信息整理与虚构演绎 · 如涉侵权请联系删除
          </p>
        </div>
      </div>
    </footer>
  );
}